export default __webpack_public_path__ + "static/media/TaxReporting300.b5764357.jpg";